"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Path = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeSvg = require("react-native-svg");

var _nativeHelpers = require("../../helpers/native-helpers");

var _excluded = ["aria-label", "desc", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Path = function (props) {
  var accessibilityLabel = props["aria-label"],
      desc = props.desc,
      style = props.style,
      rest = _objectWithoutProperties(props, _excluded);

  var nativeStyle = (0, _nativeHelpers.useGetNativeStyle)(style);
  return /*#__PURE__*/_react.default.createElement(_reactNativeSvg.Path // @ts-expect-error Accessibility props are not supported in the version of react-native-svg being used
  // https://github.com/FormidableLabs/victory/issues/2744
  , _extends({
    accessible: accessibilityLabel || undefined,
    accessibilityLabel: accessibilityLabel,
    accessibilityHint: accessibilityLabel && desc ? desc : undefined
  }, rest, nativeStyle));
};

exports.Path = Path;